import { UnitManageCard } from '@apps-common/apps/portal/pages/units/pages/manage/components'

interface IProps {
  index: number
  unitId: string
  count: number
  label: string
  Icon: any
  // Modal: any
  callback: () => void
}

export const SiteManageCardItem: React.FC<IProps> = ({ index, unitId, count, label, Icon, callback }) => {
  return (
    <UnitManageCard
      key={`site-manage-card-${index}`}
      unitId={unitId}
      count={count}
      label={label}
      Icon={Icon}
      bgClasses='bg-ctx-surface border border-ctx-border'
      textClasses='text-text'
      bgSecondaryClasses='bg-ctx-surface-2'
      textSecondaryClasses='text-text'
      bgTertiaryClasses='bg-ctx-surface-2 border border-ctx-border'
      bgActiveClasses='bg-ctx-surface'
      disabled={false}
      callback={() => callback()}
    />
  )
}
